
//STYLES
import { groupBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { ContainerModal } from "./style";
import { Accordion } from "../../../../../../../Components/CustomUi/accordion";
import { useState } from "react";
import { listarPatrimonios } from "./meta";
import { RowTable } from "../../../../../../../Components/CustomUi/table/rowTable";
import { RowItem } from "../../../../../../../Components/CustomUi/table/rowItem";
import { HeaderTable } from "../../../../../../../Components/CustomUi/table/headerTable";

//PROPS
interface Props {
    cod_patrimonio_selecionado: number;
    data_atividades: Item__Atividades[];
    data_propriedades: ItemPropriedades[];
}

export const ModalPatrimonio: React.FC<Props> = ({ cod_patrimonio_selecionado, data_atividades, data_propriedades }) => {

    const [open_accordion, setOpen_accordion] = useState<number>(null);

    function listTalhoes() {
        function nomePropriedade(cod_propriedade: number) {
            return (data_propriedades ?? []).find(i => i.cod === cod_propriedade)?.nome;
        }
        //@ts-ignore
        let todos_talhoes_da_propriedade = (data_propriedades ?? []).map(i => i.talhao)?.flat()?.filter(j => j.cod_talhao === null);
        let estrutura = (todos_talhoes_da_propriedade ?? []).map(({ cod_propriedade, ...rest }) => {
            return {
                ...rest,
                nome_propriedade: nomePropriedade(cod_propriedade),
                //@ts-ignore
                lista_atividades: (data_atividades ?? []).filter(i => i.cod_talhao === rest.cod && i.andamentos?.some(andamento => andamento.patrimonios?.some(patrimonio => patrimonio.cod_patrimonio === cod_patrimonio_selecionado)))
            }
        })

        return (estrutura ?? [])?.filter(i => i.lista_atividades.length > 0) ?? [];
    }

    return (
        <ContainerModal>
            {(listTalhoes() ?? []).map(({ nome, cod, nome_propriedade, lista_atividades }) => {
                return (
                    <Accordion

                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome}</span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        open={cod === open_accordion}
                        trigger={open_accordion === cod ? () => { setOpen_accordion(null); } : () => { setOpen_accordion(cod); }}
                        single
                        style={{ width: '100%' }}
                    >
                        <HeaderTable
                            itens={[
                                { valor: 'Atividade', width: 250 },
                                { valor: 'Patrimônio', width: 250 },
                                { valor: 'O/H percorrido', width: 130 },
                                { valor: 'O/H inicial', width: 95 },
                                { valor: 'O/H final', width: 95, },
                                { valor: 'Ponta', width: 95 },
                                { valor: 'vazao', width: 95 },
                                { valor: 'Velocidade', width: 95 },

                            ]}
                        />

                        {(listarPatrimonios(lista_atividades, data_atividades) ?? []).map(({ nome_atividade, patrimonio_nome,
                            bico, horimetro_inicial, horimetro_final, vazao, velocidade, quilometragem_inicial, quilometragem_final
                        }) => {
                            return (
                                <RowTable>
                                    <RowItem width={250} style={{ textTransform: 'capitalize', lineHeight: '1.2', fontSize: 13 }}>
                                        {String(nome_atividade)?.toLowerCase()}
                                    </RowItem>
                                    <RowItem width={250} style={{ textTransform: 'capitalize', lineHeight: '1.2', fontSize: 13, fontWeight: 600 }}>
                                        {String(patrimonio_nome)?.toLowerCase()}
                                    </RowItem>
                                    <RowItem width={130} style={{ textTransform: 'capitalize', lineHeight: '1.2', fontSize: 13, fontWeight: 600 }}>
                                        {quilometragem_inicial && quilometragem_final ?
                                            `${(Number(quilometragem_final) - Number(quilometragem_inicial)).toFixed(2)} km` :
                                            horimetro_inicial && horimetro_final ?
                                                `${(Number(horimetro_final) - Number(horimetro_inicial)).toFixed(2)} h` :
                                                '-'}
                                    </RowItem>
                                    <RowItem width={95}>
                                        {quilometragem_inicial ? `${quilometragem_inicial} km` : horimetro_inicial ? `${horimetro_inicial} h` : '-'}
                                    </RowItem>
                                    <RowItem width={95}>
                                        {quilometragem_final ? `${quilometragem_final} km` : horimetro_final ? `${horimetro_final} h` : '-'}
                                    </RowItem>
                                    <RowItem width={95}>
                                        {bico}
                                    </RowItem>
                                    <RowItem width={95}>
                                        {vazao}
                                    </RowItem>
                                    <RowItem width={95}>
                                        {velocidade}
                                    </RowItem>
                                </RowTable>
                            )
                        })}
                    </Accordion>
                )
            })}
        </ContainerModal>
    )
}